export { default as NColorPicker, colorPickerProps } from './src/ColorPicker';
